// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSavePollAnswersRequest,
  TSavePollAnswersModel,
  IMappers,
  TSavePollAnswersResponse,
  TSavePollAnswersResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSavePollAnswersModel(parameters: TSavePollAnswersRequest): TSavePollAnswersModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cian-chat-bot',
    pathApi: '/v1/save-poll-answers/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISavePollAnswersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSavePollAnswersRequest;
}

export async function fetchSavePollAnswers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISavePollAnswersOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSavePollAnswersResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSavePollAnswersModel(parameters),
    config,
  )) as FetchResponse<TSavePollAnswersResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TSavePollAnswersResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSavePollAnswersResponse>;
}
